import Vue from "vue";
import VueI18n from "vue-i18n";
import { Carousel } from "./scripts/components/carousel";
import { LazyPicture } from "./scripts/components/lazy-picture";
import { GMap } from "./scripts/components/google-map";
import { chart } from "./scripts/components/vue-chartist";
import { KeyFigures } from "./scripts/components/key-figures";
import Membership from "./scripts/components/payment-membership.vue";
import Donation from "./scripts/components/payment-donation.vue";

import "./scripts/utils/vertical-state";

import "./styles/shell.css";
import "./styles/base.css";

Vue.use(VueI18n);
Vue.use(chart);

const i18n = new VueI18n({
    locale: window.$$currentLanguage || "de",
    messages: {},
});

const vm = new Vue({
    i18n,
    data: {
        isMenuOpen: false,
        isStickyVisible: false,
        previousScrollPosition: 0,
    },
    methods: {
        openMenu() {
            this.isMenuOpen = !this.isMenuOpen;
            if (this.isMenuOpen) {  window.scrollTo(0, 0); }
        },
        setSticky() {
            const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;

            this.isStickyVisible = this.previousScrollPosition > scrollPos && scrollPos > 100;
            this.previousScrollPosition = scrollPos;
        },
    },
});

Vue.component("hero-carousel", Carousel);
Vue.component("lazy-picture", LazyPicture);
Vue.component("google-map", GMap);
Vue.component("key-figures", KeyFigures);
Vue.component("sbh-membership", Membership);
Vue.component("sbh-donation", Donation);

vm.$mount("#view");

window.addEventListener("scroll", vm.setSticky);

// Remove Honeypot text
const honeypotField = document.querySelector("#winnie") as HTMLInputElement;
if (honeypotField) {
    console.log("Clear HP field");
    honeypotField.value = "";
}



// WEBPACK FOOTER //
// ./src/main.ts